import { faEdit } from '@fortawesome/pro-regular-svg-icons'
import { Box, Flex } from '@mantine/core'

import { useQueryGetBookingById } from '@flecto/core/saas'
import { type CoreBookingProduct } from '@flecto/types'
import { Badge, Icon } from '@flecto/ui'

import { useModalBookingProductUpdate } from '../../hooks/useModalBookingProductUpdate'
import { TextBookingProductPricingRule } from '../TextBookingProductPricingRule/TextBookingProductPricingRule'

export type CellPricingTiersProps = {
  bookingProduct: CoreBookingProduct
}

export function CellPricingTiers({ bookingProduct }: CellPricingTiersProps) {
  const { openModal: openModalUpdate } = useModalBookingProductUpdate({
    bookingProduct,
    open: true,
  })

  const { data: booking } = useQueryGetBookingById({
    bookingId: bookingProduct.booking?.internal_id,
  })

  return (
    <Flex align='center' gap='xs'>
      <Badge
        color='gray'
        w='fit-content'
        rightSection={
          booking?.status !== 'completed' &&
          booking?.status !== 'canceled' && (
            <Flex ml='sm' gap='sm' align='center'>
              <Box style={{ cursor: 'pointer' }} onClick={openModalUpdate}>
                <Icon icon={faEdit} size='xs' />
              </Box>
            </Flex>
          )
        }
      >
        <TextBookingProductPricingRule bookingProduct={bookingProduct} c='black' />
      </Badge>
    </Flex>
  )
}
